// using a function to create the actions for each type of request, since they all use the same actions with different api routes
import auth from "../../../firebase/auth";
import api from "../../../api";
import { requestStatuses, uniqueServices } from "../../../libs/request-status";
import { createSuccess, createError } from "../../../libs/flash-messages";

const createActions = (route) => {
   return {
      startSetActive({ commit, state }, id) {
         const active = state.requests.filter(request => {
            return request._id === id;
         })[0];
         commit("SET_ACTIVE", active);
      },
      startUnsetActive({ commit }) {
         commit("SET_ACTIVE", null)
      },
      async startSetRequests({ commit, rootState, dispatch }) {
         const token = rootState.user.token;
         await auth.refreshFlow(auth.provider);
         try {
            const requests = await api.axiosGet(`/api/compliance/${route}/`, token);

            let augRequests = [];
            if (requests.length > 0) {
               augRequests = await requestStatuses(requests);
            }
            commit('SET_REQUESTS', augRequests);
            if (augRequests.length > 0) {
               dispatch('startSetUniqueServices');
            }
         } catch (err) {
            createError(`Failed to fetch ${route}`, err);
         }
      },
      async startSetUniqueServices({ commit, state }) {
         const services = await uniqueServices(state.requests);
         commit('SET_UNIQUE_SERVICES', services);
      },
      startUnsetRequests({ commit }) {
         commit('SET_REQUESTS', null);
      },
      startSetFilters: ({ commit }, form) => {
         commit('SET_SORT', form);
         commit('SET_STATUS', form);
         commit('SET_INCOMPLETE_SERVICES', form);
         commit('SET_NAME', form);
         commit('SET_DATE_MIN', form);
         commit('SET_DATE_MAX', form);
      },
      async startUpdateRequest({ rootState }, form) {
         const token = rootState.user.token;
         await auth.refreshFlow(auth.provider);
         const id = form._id;
         return await api.axiosPut(`/api/compliance/request-services/${id}`, form, token)
            .then(async () => {
               this._vm.$socket.io.nsps["/compliance"].emit("UPDATE_REQUEST_SERVICE", form)
               createSuccess("Successfully updated!")
            })
            .catch(err => {
               createError("Failed to update", err);
               return Promise.reject(err);
            });
      },
      async addRequestService({ rootState }, form) {
         const token = rootState.user.token;
         await auth.refreshFlow(auth.provider);
         try {
            const newRS = await api.axiosPost(`/api/compliance/request-services`, form, token);
            this._vm.$socket.io.nsps["/compliance"].emit("ADD_REQUEST_SERVICE", newRS);
            createSuccess("Successfully added service!");
         } catch (err) {
            createError("Failed to add service", err)
            return Promise.reject(err);
         }
      }
   }
}

export default createActions;